var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"warning","size":_vm.size},on:{"click":_vm.dismissFormData}},[_vm._v(_vm._s(_vm.caption || "Fechar"))])
}
var staticRenderFns = []

export { render, staticRenderFns }